

import React, { useState, useEffect } from "react";
import { Card, Button, Dropdown, Menu, Modal, Spin, Collapse, Typography, message, Tabs, List, Form, Input, Drawer, Empty, Tooltip, Progress } from "antd";
import { useNavigate } from "react-router-dom";
import courseService from "../../services/course.service";
import CourseCreateForm from "./CourseCreateForm";
import AddSubjectForm from "./AddSubjectForm";
import ControleConnaissanceManager from './ControleConnaissanceManager';
import QuizManager from "./QuizManager";
import { Editor } from "@tinymce/tinymce-react";
import API_BASE from "../../config/apiConfig";
import TrainingForm from "./TrainingForm";
import SecureContent from "../../common/SecureContent";
import {
    FileTextOutlined,
    SettingOutlined,
    TrophyOutlined,
    ContactsOutlined,
    FileImageOutlined,
    FileAddOutlined,
    BarChartOutlined,
    PaperClipOutlined,
    BookOutlined,
    DeleteOutlined,
    EditOutlined,
    EyeOutlined,
    PlusOutlined,
    ReadOutlined,
    DownOutlined,
    SearchOutlined,
    ReloadOutlined,
    AppstoreOutlined,
    CheckCircleOutlined,
    ExclamationCircleOutlined,
    PlayCircleOutlined,
    ClockCircleOutlined,
    FolderOpenOutlined,
    TagOutlined,
    MoreOutlined,
    RocketOutlined
} from "@ant-design/icons";
import BadgeManager from "./BadgeManager";
import CertificateGenerator from "./CertificateGenerator";
import ManualCertificateGenerator from "./ManualCertificateGenerator";
import EvaluationsManager from "./EvaluationsManager";
import TotalPourcentageViewer from "./TotalPourcentageViewer";
import { ensureNotExceed100 } from "../admin_and_user/ensureNotExceed100";
import PlanManager from "./PlanManager";
import NewsManager from "./NewsManager";
import SalesRequestManager from "./SalesRequestManager";
import CourseFullViewer from "../../components/user/CourseFullViewer";
import ResourceManager from "../moderateur/ressources/ResourceManager";
import AttachmentManager from "./attachment/AttachmentManager";

const API_BASE_URL = `${API_BASE}/images/proxy`;

/**
 * Transforme les URLs relatives /api/... et localhost en URLs absolues avec API_BASE
 * ET ajoute les attributs de protection sur les vidéos (nodownload)
 */
const transformContentUrls = (content) => {
    if (!content || typeof content !== 'string') return content;

    let transformed = content
        .replace(/http:\/\/localhost:3000\/api\//g, `${API_BASE}/`)
        .replace(/https:\/\/localhost:3000\/api\//g, `${API_BASE}/`)
        .replace(/http:\/\/localhost:8080\/api\//g, `${API_BASE}/`)
        .replace(/https:\/\/localhost:8080\/api\//g, `${API_BASE}/`)
        .replace(/src="\/api\//g, `src="${API_BASE}/`)
        .replace(/src='\/api\//g, `src='${API_BASE}/`)
        .replace(/href="\/api\//g, `href="${API_BASE}/`)
        .replace(/href='\/api\//g, `href='${API_BASE}/`)
        .replace(/poster="\/api\//g, `poster="${API_BASE}/`)
        .replace(/poster='\/api\//g, `poster='${API_BASE}/`);

    transformed = transformed.replace(
        /<video([^>]*)>/gi,
        (match, attrs) => {
            let newAttrs = attrs.replace(/controlsList="[^"]*"/gi, '').replace(/controlslist="[^"]*"/gi, '');
            newAttrs += ' controlsList="nodownload nofullscreen noremoteplayback"';
            if (!attrs.includes('disablePictureInPicture')) {
                newAttrs += ' disablePictureInPicture';
            }
            if (!attrs.includes('oncontextmenu')) {
                newAttrs += ' oncontextmenu="return false;"';
            }
            newAttrs = newAttrs.replace(/\s+/g, ' ').trim();
            return `<video ${newAttrs}>`;
        }
    );

    return transformed;
};

const ModeratorCourses = () => {
    // ==================== STATES ====================
    const [refresh, setRefresh] = useState(false);
    const [loadingGlobal, setLoadingGlobal] = useState(false);
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user?.id;
    // ✅ NOUVEAU : Détection du rôle Admin
    //    Seuls les admins peuvent générer des certificats manuellement
    const userRoles = user?.roles || [];
    const isAdmin = userRoles.includes("ROLE_ADMIN");

    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [isAddingSubject, setIsAddingSubject] = useState(false);
    const navigate = useNavigate();
    const [selectedAttachmentFile, setSelectedAttachmentFile] = useState(null);
    const [attachments, setAttachments] = useState([]);
    const [loadingAttachments, setLoadingAttachments] = useState(false);
    const [resources, setResources] = useState([]);
    const [selectedSubjectId, setSelectedSubjectId] = useState(null);
    const [selectedContent, setSelectedContent] = useState('');
    const [addSubjectFormKey, setAddSubjectFormKey] = useState(0);
    const [isAttachmentsModalVisible, setIsAttachmentsModalVisible] = useState(false);
    const [isResourcesModalVisible, setIsResourcesModalVisible] = useState(false);
    const [attachmentsBySubject, setAttachmentsBySubject] = useState({});
    const [resourcesBySubject, setResourcesBySubject] = useState({});
    const [loadingUpload, setLoadingUpload] = useState(false);
    const [selectionMode, setSelectionMode] = useState("content");
    const [isAddingResource, setIsAddingResource] = useState(false);
    const [newResourceContent, setNewResourceContent] = useState('');
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [newQuizTitle, setNewQuizTitle] = useState("");
    const [selectedQuiz, setSelectedQuiz] = useState(null);
    const [loadingAddResourceBtn, setLoadingAddResourceBtn] = useState(false);
    const [deletedCourses, setDeletedCourses] = useState([]);
    const [showDeletedCourses, setShowDeletedCourses] = useState(false);
    const [loadingDeleted, setLoadingDeleted] = useState(false);
    const [isManagementModalVisible, setIsManagementModalVisible] = useState(false);
    const [selectedCourseSubjects, setSelectedCourseSubjects] = useState([]);
    const [isSubjectsModalVisible, setIsSubjectsModalVisible] = useState(false);
    const [groupedSubjects, setGroupedSubjects] = useState({});
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [drawerKey, setDrawerKey] = useState(0);
    const [selectedSubject, setSelectedSubject] = useState(null);
    const [isEditingSubject, setIsEditingSubject] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [isPreviewModalVisible, setIsPreviewModalVisible] = useState(false);
    const [previewCourse, setPreviewCourse] = useState(null);
    const [loadingSubjectsId, setLoadingSubjectsId] = useState(null);
    const [loadingType, setLoadingType] = useState(null);
    const { Title, Text } = Typography;
    const { TabPane } = Tabs;

    // ==================== FETCH FUNCTIONS ====================
    const fetchResources = async (courseId) => {
        try {
            const response = await courseService.getResourcesByCourse(courseId);
            setResources(response);
        } catch (error) {
            console.error("Erreur lors de la récupération des ressources :", error);
        }
    };

    const fetchAttachmentsBySubject = async (subjectId) => {
        try {
            const response = await courseService.getAttachmentsBySubject(subjectId);
            setAttachmentsBySubject(prev => ({ ...prev, [subjectId]: response }));
        } catch (error) {
            console.error("Erreur lors de la récupération des pièces jointes:", error);
        }
    };

    const fetchResourcesBySubject = async (subjectId) => {
        try {
            const response = await courseService.getResourcesBySubject(subjectId);
            setResourcesBySubject(prev => ({ ...prev, [subjectId]: response }));
        } catch (error) {
            console.error("Erreur lors de la récupération des ressources:", error);
        }
    };

    const fetchAttachments = async (courseId) => {
        setLoadingAttachments(true);
        try {
            const response = await courseService.getAttachmentsByCourse(courseId);
            setAttachments(response);
        } catch (error) {
            console.error("Erreur lors du chargement des pièces jointes :", error);
        } finally {
            setLoadingAttachments(false);
        }
    };

    const reloadCourses = React.useCallback(async () => {
        setLoadingGlobal(true);
        try {
            const resp = await courseService.getCoursesByModerator(userId);
            const updated = resp.map((course) => ({
                ...course,
                imageUrl: course.image
                    ? `${API_BASE_URL}?url=${encodeURIComponent(course.image)}`
                    : "/default-image.png"
            }));
            setCourses(updated);
        } catch (e) {
            console.error(e);
            message.error("Erreur lors du rechargement des cours");
        } finally {
            setLoadingGlobal(false);
        }
    }, [userId]);

    const reloadCourseDetail = React.useCallback(async (courseId) => {
        if (!courseId) return;
        setLoadingSubjectsId(courseId);
        try {
            await fetchResources(courseId);
            const response = await courseService.getSubjectsWithDetails(courseId);
            setSelectedCourseSubjects(response);

            const grouped = response.reduce((acc, subject) => {
                if (!acc[subject.group_name]) acc[subject.group_name] = {};
                if (!acc[subject.group_name][subject.title]) acc[subject.group_name][subject.title] = [];
                acc[subject.group_name][subject.title].push(subject);
                return acc;
            }, {});
            setGroupedSubjects(grouped);
        } catch (e) {
            console.error(e);
            message.error("Erreur lors du rechargement du cours");
        } finally {
            setLoadingSubjectsId(null);
        }
    }, []);

    const loadDeletedCourses = async () => {
        setLoadingDeleted(true);
        try {
            const response = await courseService.getDeletedCourses();
            setDeletedCourses(response);
        } catch (error) {
            message.error("Erreur lors du chargement des cours supprimés");
        } finally {
            setLoadingDeleted(false);
        }
    };

    // ==================== INITIAL LOAD ====================
    useEffect(() => {
        const fetchCourses = async () => {
            try {
                const response = await courseService.getCoursesByModerator(userId);
                const updatedCourses = response.map((course) => ({
                    ...course,
                    imageUrl: course.image
                        ? `${API_BASE_URL}?url=${encodeURIComponent(course.image)}`
                        : "/default-image.png"
                }));
                setCourses(updatedCourses);
            } catch (error) {
                console.error("Erreur lors du chargement des cours :", error);
            } finally {
                setLoading(false);
            }
        };
        fetchCourses();
    }, [userId]);

    // ==================== HANDLERS ====================
    const handleEditCourse = (course) => {
        setSelectedCourse(course);
        setIsEditing(true);
    };

    const handlePreviewCourse = (course) => {
        setPreviewCourse(course);
        setIsPreviewModalVisible(true);
    };

    const handleAddSubject = async (course) => {
        setSelectedCourse(course);
        setSelectedSubject(null);
        setLoadingSubjectsId(course.id);
        setLoadingType("elements");

        try {
            await fetchResources(course.id);
            setAddSubjectFormKey(prev => prev + 1);
            setIsAddingSubject(true);
        } catch (error) {
            message.error("Erreur lors du chargement des ressources.");
        } finally {
            setLoadingSubjectsId(null);
        }
    };

    const handleShowSubjects = async (course) => {
        setSelectedCourse(course);
        setLoadingSubjectsId(course.id);
        setLoadingType("sujets");

        try {
            const subjectsWithDetails = await courseService.getSubjectsWithDetails(course.id);
            setSelectedCourseSubjects(subjectsWithDetails);

            const grouped = subjectsWithDetails.reduce((acc, subject) => {
                if (!acc[subject.group_name]) acc[subject.group_name] = {};
                if (!acc[subject.group_name][subject.title]) {
                    acc[subject.group_name][subject.title] = [];
                }
                acc[subject.group_name][subject.title].push(subject);
                return acc;
            }, {});

            setGroupedSubjects(grouped);
            setIsSubjectsModalVisible(true);
        } catch (error) {
            console.error("Erreur API:", error);
            message.error("Erreur lors du chargement des sujets");
        } finally {
            setLoadingSubjectsId(null);
        }
    };

    const handleEditSubject = (subject) => {
        setSelectedSubject({
            ...subject,
            courseId: subject.courseId || selectedCourse?.id,
        });
        setIsEditingSubject(true);
    };

    const handleManageAttachments = (subject) => {
        setSelectedSubject(subject);
        setIsAttachmentsModalVisible(true);
    };

    const handleManageResources = (subject) => {
        setSelectedSubject(subject);
        setIsResourcesModalVisible(true);
    };

    const handleSubjectSelection = (subject, mode = "content") => {
        setSelectedSubjectId(subject.id);
        setSelectionMode(mode);
        if (mode === "content") {
            setSelectedContent(subject.content || "<p>Aucun contenu disponible.</p>");
        }
    };

    const handleDeleteSubject = (subjectId) => {
        Modal.confirm({
            title: "Confirmer la suppression",
            icon: <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />,
            content: "Êtes-vous sûr de vouloir supprimer ce sujet ? Cette action est irréversible.",
            okText: "Supprimer",
            okType: "danger",
            cancelText: "Annuler",
            onOk: async () => {
                setLoading(true);
                try {
                    await courseService.deleteSubject(subjectId);
                    message.success("Sujet supprimé avec succès.");
                    await reloadCourses();
                    await reloadCourseDetail(selectedCourse?.id);
                } catch (error) {
                    message.error("Erreur lors de la suppression du sujet.");
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    const handleRestoreCourse = (courseId) => {
        Modal.confirm({
            title: "Restaurer ce cours",
            icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
            content: "Voulez-vous restaurer ce cours ? Il redeviendra visible pour les étudiants.",
            okText: "Restaurer",
            okType: "primary",
            cancelText: "Annuler",
            onOk: async () => {
                setLoadingDeleted(true);
                try {
                    await courseService.restoreCourse(courseId);
                    message.success("Cours restauré avec succès !");
                    await reloadCourses();
                    await loadDeletedCourses();
                } catch (error) {
                    message.error("Erreur lors de la restauration.");
                } finally {
                    setLoadingDeleted(false);
                }
            }
        });
    };

    const handleDeleteCourse = (courseId) => {
        Modal.confirm({
            title: "Désactiver ce cours",
            icon: <ExclamationCircleOutlined style={{ color: '#faad14' }} />,
            content: "Ce cours ne sera plus visible pour les étudiants mais pourra être restauré.",
            okText: "Désactiver",
            okType: "danger",
            cancelText: "Annuler",
            onOk: async () => {
                setLoading(true);
                try {
                    await courseService.softDeleteCourse(courseId);
                    message.success("Cours désactivé avec succès !");
                    await reloadCourses();
                    if (showDeletedCourses) await loadDeletedCourses();
                } catch (error) {
                    message.error("Erreur lors de la désactivation.");
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    // Filter courses by search term
    const filteredCourses = courses.filter(course =>
        course.title?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // ==================== LOADING STATE ====================
    if (loading) {
        return (
            <div style={{
                minHeight: '100vh',
                background: '#f7f8fa',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '40px 20px',
            }}>
                <style>{`
                @keyframes nomidya-pulse {
                    0%, 100% { transform: scale(1); opacity: 1; }
                    50% { transform: scale(1.1); opacity: 0.7; }
                }
                @keyframes nomidya-rotate {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                @keyframes nomidya-fade-in {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes nomidya-bounce {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-12px); }
                }
                @keyframes nomidya-progress {
                    0% { width: 0%; margin-left: 0%; }
                    50% { width: 70%; margin-left: 15%; }
                    100% { width: 0%; margin-left: 100%; }
                }
                .nomidya-loader-card {
                    background: white;
                    border-radius: 24px;
                    padding: 60px 50px;
                    box-shadow: 0 25px 50px rgba(0, 84, 166, 0.12);
                    text-align: center;
                    max-width: 500px;
                    width: 100%;
                    animation: nomidya-fade-in 0.6s ease-out;
                    border: 1px solid rgba(0, 84, 166, 0.08);
                }
                .nomidya-loader-icon-wrapper {
                    position: relative;
                    width: 100px;
                    height: 100px;
                    margin: 0 auto 32px;
                }
                .nomidya-loader-ring {
                    position: absolute;
                    top: 0; left: 0;
                    width: 100px; height: 100px;
                    border-radius: 50%;
                    border: 4px solid transparent;
                    border-top-color: #0054A6;
                    border-right-color: #E8860C;
                    animation: nomidya-rotate 1.2s linear infinite;
                }
                .nomidya-loader-ring-2 {
                    position: absolute;
                    top: 10px; left: 10px;
                    width: 80px; height: 80px;
                    border-radius: 50%;
                    border: 3px solid transparent;
                    border-bottom-color: #003B75;
                    border-left-color: #FF8C00;
                    animation: nomidya-rotate 1.5s linear infinite reverse;
                }
                .nomidya-loader-center {
                    position: absolute;
                    top: 50%; left: 50%;
                    transform: translate(-50%, -50%);
                    width: 50px; height: 50px;
                    background: linear-gradient(135deg, #0054A6 0%, #E8860C 100%);
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    font-size: 24px;
                    animation: nomidya-pulse 2s ease-in-out infinite;
                    box-shadow: 0 8px 24px rgba(0, 84, 166, 0.3);
                }
                .nomidya-loader-title {
                    font-size: 22px;
                    font-weight: 700;
                    color: #003B75;
                    margin: 0 0 8px;
                    letter-spacing: -0.3px;
                }
                .nomidya-loader-subtitle {
                    font-size: 14px;
                    color: #6b7280;
                    margin: 0 0 24px;
                    line-height: 1.6;
                }
                .nomidya-loader-dots {
                    display: flex;
                    justify-content: center;
                    gap: 10px;
                    margin-top: 20px;
                }
                .nomidya-loader-dot {
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                    animation: nomidya-bounce 1.4s ease-in-out infinite;
                }
                .nomidya-loader-dot:nth-child(1) { background: #0054A6; animation-delay: 0s; }
                .nomidya-loader-dot:nth-child(2) { background: #E8860C; animation-delay: 0.2s; }
                .nomidya-loader-dot:nth-child(3) { background: #003B75; animation-delay: 0.4s; }
                .nomidya-loader-progress {
                    width: 100%;
                    height: 4px;
                    background: #e8eef5;
                    border-radius: 4px;
                    overflow: hidden;
                    margin-top: 24px;
                }
                .nomidya-loader-progress-bar {
                    height: 100%;
                    background: linear-gradient(90deg, #0054A6 0%, #E8860C 100%);
                    border-radius: 4px;
                    width: 30%;
                    animation: nomidya-progress 2s ease-in-out infinite;
                }
            `}</style>

                <div className="nomidya-loader-card">
                    <div className="nomidya-loader-icon-wrapper">
                        <div className="nomidya-loader-ring"></div>
                        <div className="nomidya-loader-ring-2"></div>
                        <div className="nomidya-loader-center">
                            <BookOutlined />
                        </div>
                    </div>

                    <h2 className="nomidya-loader-title">
                        Chargement de vos cours
                    </h2>

                    <p className="nomidya-loader-subtitle">
                        Préparation de votre espace de gestion...
                    </p>

                    <div className="nomidya-loader-dots">
                        <div className="nomidya-loader-dot"></div>
                        <div className="nomidya-loader-dot"></div>
                        <div className="nomidya-loader-dot"></div>
                    </div>

                    <div className="nomidya-loader-progress">
                        <div className="nomidya-loader-progress-bar"></div>
                    </div>
                </div>
            </div>
        );
    }

    // ==================== MAIN RENDER ====================
    return (
        <div className="mc-container">
            {/* ==================== CSS STYLES ==================== */}
            <style>{`
            .mc-container {
                min-height: 100vh;
                background: #f0f2f5;
            }

            video::-internal-media-controls-download-button {
                display: none !important;
            }
            video::-webkit-media-controls-download-button {
                display: none !important;
            }
            video::-webkit-media-controls-enclosure {
                overflow: hidden !important;
            }
            video::-webkit-media-controls-panel {
                width: calc(100% + 30px) !important;
            }
            video::-moz-media-controls-download-button {
                display: none !important;
            }
            video {
                -webkit-user-select: none !important;
                -moz-user-select: none !important;
                -ms-user-select: none !important;
                user-select: none !important;
                -webkit-touch-callout: none !important;
                -webkit-user-drag: none !important;
                user-drag: none !important;
            }

            .mc-header {
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                padding: 16px 24px;
                color: white;
            }
            .mc-header-content {
                max-width: 1400px;
                margin: 0 auto;
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 20px;
                flex-wrap: wrap;
            }
            .mc-header-title {
                display: flex;
                align-items: center;
                gap: 12px;
            }
            .mc-header-icon {
                width: 42px;
                height: 42px;
                background: rgba(255,255,255,0.2);
                border-radius: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 20px;
            }
            .mc-header h1 {
                margin: 0;
                font-size: 20px;
                font-weight: 700;
            }
            .mc-header-subtitle {
                margin: 2px 0 0;
                opacity: 0.85;
                font-size: 12px;
            }
            
            .mc-stats {
                display: flex;
                gap: 12px;
                align-items: center;
            }
            .mc-stat-card {
                background: rgba(255,255,255,0.15);
                border-radius: 10px;
                padding: 10px 20px;
                backdrop-filter: blur(10px);
                display: flex;
                align-items: center;
                gap: 10px;
            }
            .mc-stat-value {
                font-size: 24px;
                font-weight: 700;
                line-height: 1;
            }
            .mc-stat-label {
                font-size: 11px;
                opacity: 0.9;
            }
            
            .mc-header-btn {
                background: white !important;
                color: #667eea !important;
                border: none !important;
                height: 42px;
                padding: 0 24px;
                border-radius: 10px;
                font-weight: 600;
                box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                display: flex;
                align-items: center;
                gap: 8px;
                cursor: pointer;
                transition: all 0.2s ease;
                font-size: 14px;
                white-space: nowrap;
            }
            .mc-header-btn:hover {
                transform: translateY(-2px);
                box-shadow: 0 6px 16px rgba(0,0,0,0.2);
            }

            .mc-content {
                max-width: 1400px;
                margin: 0 auto;
                padding: 20px 24px;
            }

            .mc-toolbar {
                background: white;
                border-radius: 12px;
                padding: 14px 18px;
                margin-bottom: 20px;
                box-shadow: 0 2px 8px rgba(0,0,0,0.06);
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
                gap: 12px;
            }
            .mc-toolbar-left {
                display: flex;
                gap: 8px;
                flex-wrap: wrap;
            }
            .mc-toolbar-right {
                display: flex;
                gap: 10px;
                align-items: center;
            }
            .mc-search {
                position: relative;
            }
            .mc-search-icon {
                position: absolute;
                left: 12px;
                top: 50%;
                transform: translateY(-50%);
                color: #bfbfbf;
                font-size: 14px;
            }
            .mc-search-input {
                padding: 8px 14px 8px 36px;
                border: 1px solid #d9d9d9;
                border-radius: 8px;
                width: 220px;
                font-size: 13px;
                transition: all 0.2s;
                outline: none;
            }
            .mc-search-input:focus {
                border-color: #667eea;
                box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
            }
            .mc-tab-btn {
                display: flex;
                align-items: center;
                gap: 6px;
                padding: 8px 16px;
                border-radius: 8px;
                border: none;
                cursor: pointer;
                font-size: 13px;
                font-weight: 500;
                transition: all 0.2s ease;
            }
            .mc-tab-btn-active {
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                color: white;
                box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
            }
            .mc-tab-btn-inactive {
                background: #f0f0f0;
                color: #595959;
            }
            .mc-tab-btn-inactive:hover {
                background: #e8e8e8;
            }

            .mc-grid {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
                gap: 20px;
            }

            .mc-card {
                background: white;
                border-radius: 14px;
                overflow: hidden;
                box-shadow: 0 4px 12px rgba(0,0,0,0.08);
                transition: all 0.3s ease;
                border: 1px solid #f0f0f0;
            }
            .mc-card:hover {
                transform: translateY(-4px);
                box-shadow: 0 12px 24px rgba(0,0,0,0.12);
            }
            .mc-card-image-container {
                position: relative;
                overflow: hidden;
            }
            .mc-card-image {
                height: 160px;
                width: 100%;
                object-fit: cover;
                transition: transform 0.3s ease;
            }
            .mc-card:hover .mc-card-image {
                transform: scale(1.05);
            }
            .mc-card-badge {
                position: absolute;
                top: 10px;
                left: 10px;
                background: rgba(255,255,255,0.95);
                padding: 5px 10px;
                border-radius: 6px;
                font-size: 11px;
                font-weight: 600;
                color: #667eea;
                display: flex;
                align-items: center;
                gap: 5px;
                box-shadow: 0 2px 8px rgba(0,0,0,0.1);
            }
            .mc-card-menu {
                position: absolute;
                top: 10px;
                right: 10px;
                background: rgba(255,255,255,0.95);
                border-radius: 6px;
                box-shadow: 0 2px 8px rgba(0,0,0,0.1);
            }
            .mc-card-content {
                padding: 16px;
            }
            .mc-card-title {
                font-size: 15px;
                font-weight: 600;
                color: #262626;
                margin-bottom: 10px;
                line-height: 1.4;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
            }
            .mc-card-meta {
                display: flex;
                gap: 12px;
                margin-bottom: 12px;
                font-size: 12px;
                color: #8c8c8c;
            }
            .mc-meta-item {
                display: flex;
                align-items: center;
                gap: 5px;
            }
            .mc-card-actions {
                display: flex;
                gap: 8px;
            }
            .mc-action-btn {
                flex: 1;
                height: 36px;
                border-radius: 8px;
                font-weight: 500;
                font-size: 13px;
                transition: all 0.2s ease;
            }
            .mc-action-btn:hover {
                transform: translateY(-2px);
            }
            .mc-action-btn-primary {
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
                border: none !important;
                color: white !important;
            }
            .mc-action-btn-green {
                background: #52c41a !important;
                border: none !important;
                color: white !important;
            }
            .mc-action-btn-green:hover {
                background: #389e0d !important;
            }

            .mc-card-deleted {
                opacity: 0.85;
                border: 2px dashed #ff4d4f !important;
            }
            .mc-card-deleted .mc-card-image {
                filter: grayscale(60%);
            }
            .mc-deleted-badge {
                position: absolute;
                top: 10px;
                right: 10px;
                background: #ff4d4f;
                color: white;
                padding: 5px 10px;
                border-radius: 6px;
                font-size: 10px;
                font-weight: 700;
                text-transform: uppercase;
            }

            .mc-empty {
                text-align: center;
                padding: 50px 20px;
                background: white;
                border-radius: 14px;
                box-shadow: 0 4px 12px rgba(0,0,0,0.08);
            }

            .mc-subject-item {
                padding: 14px;
                margin-bottom: 10px;
                background: #fafafa;
                border-radius: 10px;
                border: 1px solid #f0f0f0;
                transition: background 0.2s;
            }
            .mc-subject-item:hover {
                background: #f5f5f5;
            }
            .mc-subject-title {
                font-weight: 600;
                margin-bottom: 10px;
                font-size: 13px;
                color: #262626;
            }
            .mc-subject-actions {
                display: flex;
                gap: 6px;
                flex-wrap: wrap;
            }

            .ant-modal-content {
                border-radius: 14px !important;
                overflow: hidden;
            }
            .ant-modal-header {
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
                padding: 16px 20px !important;
                border: none !important;
            }
            .ant-modal-title {
                color: white !important;
                font-weight: 600 !important;
            }
            .ant-modal-close {
                color: white !important;
            }
            .ant-collapse-header {
                font-weight: 500 !important;
            }

            @media (max-width: 992px) {
                .mc-header-content {
                    flex-direction: column;
                    align-items: flex-start;
                }
                .mc-stats {
                    width: 100%;
                    justify-content: flex-start;
                }
            }
            @media (max-width: 768px) {
                .mc-header {
                    padding: 14px 16px;
                }
                .mc-header h1 {
                    font-size: 18px;
                }
                .mc-content {
                    padding: 16px;
                }
                .mc-grid {
                    grid-template-columns: 1fr;
                }
                .mc-toolbar {
                    flex-direction: column;
                    align-items: stretch;
                }
                .mc-search-input {
                    width: 100%;
                }
                .mc-stats {
                    flex-wrap: wrap;
                }
                .mc-stat-card {
                    flex: 1;
                    min-width: 100px;
                }
            }
            .mc-status-badge {
                position: absolute;
                bottom: 10px;
                right: 10px;
                padding: 5px 12px;
                border-radius: 20px;
                font-size: 11px;
                font-weight: 700;
                text-transform: uppercase;
                letter-spacing: 0.5px;
                display: flex;
                align-items: center;
                gap: 5px;
                box-shadow: 0 2px 8px rgba(0,0,0,0.2);
                backdrop-filter: blur(10px);
                z-index: 2;
            }

            .mc-status-approved {
                background: linear-gradient(135deg, #52c41a 0%, #389e0d 100%);
                color: white;
            }

            .mc-status-pending {
                background: linear-gradient(135deg, #faad14 0%, #d48806 100%);
                color: white;
                animation: mc-pulse-pending 2s ease-in-out infinite;
            }

            @keyframes mc-pulse-pending {
                0%, 100% { opacity: 1; }
                50% { opacity: 0.85; }
            }

            .mc-card.mc-card-pending {
                border: 2px solid #ffe58f;
                background: linear-gradient(180deg, #fffbf0 0%, white 50%);
            }

            .mc-card.mc-card-pending:hover {
                border-color: #faad14;
                box-shadow: 0 12px 24px rgba(250, 173, 20, 0.2);
            }

            .mc-stat-card-success {
                background: rgba(82, 196, 26, 0.25) !important;
                border: 1px solid rgba(82, 196, 26, 0.4);
            }

            .mc-stat-card-warning {
                background: rgba(250, 173, 20, 0.25) !important;
                border: 1px solid rgba(250, 173, 20, 0.4);
            }
        `}</style>

            {/* ==================== HEADER COMPACT ==================== */}
            <header className="mc-header">
                <div className="mc-header-content">
                    <div className="mc-header-title">
                        <div className="mc-header-icon">
                            <BookOutlined />
                        </div>
                        <div>
                            <h1>Mes Cours</h1>
                            <p className="mc-header-subtitle">Gérez et organisez vos formations</p>
                        </div>
                    </div>

                    <div className="mc-stats">
                        <div className="mc-stat-card">
                            <div className="mc-stat-value">{courses.length}</div>
                            <div className="mc-stat-label">Total</div>
                        </div>
                        <div className="mc-stat-card mc-stat-card-success">
                            <div className="mc-stat-value">{courses.filter(c => c.approved).length}</div>
                            <div className="mc-stat-label">Approuvés</div>
                        </div>
                        <div className="mc-stat-card mc-stat-card-warning">
                            <div className="mc-stat-value">{courses.filter(c => !c.approved).length}</div>
                            <div className="mc-stat-label">En attente</div>
                        </div>
                        <div className="mc-stat-card">
                            <div className="mc-stat-value">
                                {courses.reduce((sum, c) => sum + (parseInt(c.lessons) || 0), 0)}
                            </div>
                            <div className="mc-stat-label">Leçons</div>
                        </div>
                    </div>

                    <button className="mc-header-btn" onClick={() => navigate("/mod/create-course")}>
                        <PlusOutlined />
                        Nouveau cours
                    </button>
                </div>
            </header>

            {/* ==================== MAIN CONTENT ==================== */}
            <main className="mc-content">
                <div className="mc-toolbar">
                    <div className="mc-toolbar-left">
                        <button
                            className="mc-tab-btn mc-tab-btn-active"
                        >
                            <CheckCircleOutlined />
                            Mes cours ({courses.length})
                        </button>
                    </div>

                    <div className="mc-toolbar-right">
                        <div className="mc-search">
                            <SearchOutlined className="mc-search-icon" />
                            <input
                                type="text"
                                placeholder="Rechercher un cours..."
                                className="mc-search-input"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <Tooltip title="Rafraîchir">
                            <Button
                                icon={<ReloadOutlined spin={loadingGlobal} />}
                                onClick={reloadCourses}
                                style={{ borderRadius: '8px' }}
                            />
                        </Tooltip>
                    </div>
                </div>

                {filteredCourses.length > 0 ? (
                    <div className="mc-grid">
                        {filteredCourses.map((course) => (
                            <div key={course.id} className={`mc-card ${!course.approved ? 'mc-card-pending' : ''}`}>
                                <div className="mc-card-image-container">
                                    <img
                                        alt={course.title}
                                        src={course.imageUrl || "/default-image.png"}
                                        className="mc-card-image"
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = "/default-image.png";
                                        }}
                                    />
                                    <div className="mc-card-badge">
                                        <PlayCircleOutlined />
                                        {course.lessons || 0} leçons
                                    </div>

                                    <div className={`mc-status-badge ${course.approved ? 'mc-status-approved' : 'mc-status-pending'}`}>
                                        {course.approved ? (
                                            <>
                                                <CheckCircleOutlined /> Approuvé
                                            </>
                                        ) : (
                                            <>
                                                <ClockCircleOutlined /> En attente
                                            </>
                                        )}
                                    </div>

                                    <div className="mc-card-menu">
                                        <Dropdown
                                            overlay={
                                                <Menu style={{ borderRadius: '10px', padding: '8px' }}>
                                                    <Menu.Item key="preview" icon={<EyeOutlined style={{ color: '#52c41a' }} />} onClick={() => handlePreviewCourse(course)}>
                                                        Prévisualiser comme étudiant
                                                    </Menu.Item>
                                                    <Menu.Item key="edit" icon={<EditOutlined style={{ color: '#1890ff' }} />} onClick={() => handleEditCourse(course)}>
                                                        Modifier le cours
                                                    </Menu.Item>
                                                    <Menu.Divider />
                                                    <Menu.Item key="delete" icon={<DeleteOutlined />} onClick={() => handleDeleteCourse(course.id)} danger>
                                                        Désactiver le cours
                                                    </Menu.Item>
                                                </Menu>
                                            }
                                            trigger={["click"]}
                                        >
                                            <Button type="text" icon={<MoreOutlined style={{ fontSize: '20px' }} />} />
                                        </Dropdown>
                                    </div>
                                </div>

                                <div className="mc-card-content">
                                    <h3 className="mc-card-title">{course.title}</h3>

                                    <div className="mc-card-meta">
                                        <span className="mc-meta-item">
                                            <ClockCircleOutlined />
                                            {course.duration || "Non défini"}
                                        </span>
                                        <span className="mc-meta-item">
                                            <TagOutlined />
                                            {course.category?.libelle || "Sans catégorie"}
                                        </span>
                                    </div>

                                    <div className="mc-card-actions">
                                        <Button
                                            className="mc-action-btn mc-action-btn-primary"
                                            icon={<FolderOpenOutlined />}
                                            onClick={() => handleAddSubject(course)}
                                            loading={loadingSubjectsId === course.id && loadingType === "elements"}
                                        >
                                            Éléments
                                        </Button>
                                        <Button
                                            className="mc-action-btn mc-action-btn-green"
                                            icon={<EyeOutlined />}
                                            onClick={() => handleShowSubjects(course)}
                                            loading={loadingSubjectsId === course.id && loadingType === "sujets"}
                                        >
                                            Sujets
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="mc-empty">
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={searchTerm ? `Aucun cours trouvé pour "${searchTerm}"` : "Aucun cours disponible"}
                        />
                        {!searchTerm && (
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={() => navigate("/mod/create-course")}
                                style={{ marginTop: '20px', borderRadius: '8px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', border: 'none' }}
                            >
                                Créer votre premier cours
                            </Button>
                        )}
                    </div>
                )}
            </main>

            {/* ==================== MODALS ==================== */}

            <Modal open={isEditing} footer={null} width="98%" style={{ top: 10, maxWidth: '1600px' }} bodyStyle={{ padding: 0, maxHeight: 'calc(100vh - 80px)', overflowY: 'auto' }} onCancel={() => setIsEditing(false)} destroyOnClose closable={true}>
                <CourseCreateForm btnText="Modifier le cours" initialData={selectedCourse} onClose={() => setIsEditing(false)} onSaved={async () => { await reloadCourses(); setIsEditing(false); message.success("Cours modifié !"); }} />
            </Modal>

            <Modal open={isEditingSubject} title="Modifier le sujets" footer={null} width="95%" style={{ top: 20 }} bodyStyle={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto' }} onCancel={() => setIsEditingSubject(false)} destroyOnClose>
                {selectedSubject && <AddSubjectForm subject={selectedSubject} onClose={() => setIsEditingSubject(false)} onSaved={async () => { await reloadCourses(); await reloadCourseDetail(selectedCourse?.id); setIsEditingSubject(false); message.success("Sujet modifié !"); }} />}
            </Modal>

            <Modal open={isAddingSubject} title={`Gérer les éléments : ${selectedCourse?.title || ''}`} footer={null} width="98%" style={{ top: 10 }} bodyStyle={{ height: 'calc(100vh - 120px)', overflowY: 'auto', padding: '20px' }} onCancel={() => setIsAddingSubject(false)} destroyOnClose maskClosable={false}>

                <div style={{ position: "relative" }}>
                    <Tabs defaultActiveKey="1" type="card" size="large" onChange={(key) => { if (key === "3") fetchAttachments(selectedCourse?.id); }}>
                        <TabPane tab={<span><FileTextOutlined /> Sujet</span>} key="1">
                            <Card title="Ajouter un sujet" bordered={false}>
                                <AddSubjectForm key={`${selectedCourse?.id}-${addSubjectFormKey}`} courseId={selectedCourse?.id} subject={null} onClose={() => setIsAddingSubject(false)} onSaved={async () => { await reloadCourses(); await reloadCourseDetail(selectedCourse?.id); message.success("Sujet ajouté !"); }} />
                            </Card>
                        </TabPane>
                        <TabPane tab={<span><FileAddOutlined /> Contrôle</span>} key="2">
                            <ControleConnaissanceManager courseId={selectedCourse?.id} showInPage={true} onSaved={() => reloadCourseDetail(selectedCourse?.id)} />
                        </TabPane>
                        <TabPane tab={<span><FileAddOutlined /> Évaluation</span>} key="3">
                            <EvaluationsManager courseId={selectedCourse?.id} showInPage={true} onSaved={() => reloadCourseDetail(selectedCourse?.id)} />
                        </TabPane>
                        <TabPane tab={<span><ReadOutlined /> Entraînement</span>} key="4">
                            <TrainingForm courseId={selectedCourse?.id} />
                        </TabPane>
                        <TabPane tab={<span><TrophyOutlined /> Certificats</span>} key="5">
                            <Tabs defaultActiveKey="template" type="card" size="small">
                                <TabPane tab={<span><SettingOutlined /> Modèle du certificat</span>} key="template">
                                    <CertificateGenerator
                                        studentName="Nom"
                                        courseTitle={selectedCourse?.title || "Cours"}
                                        courseId={selectedCourse?.id}
                                    />
                                </TabPane>

                                {/* ✅ NOUVEAU : Onglet "Génération manuelle" UNIQUEMENT pour ADMIN */}
                                {/*    Les modérateurs ne voient pas cet onglet : seul l'admin peut générer */}
                                {/*    et envoyer des certificats manuellement aux étudiants */}
                                {isAdmin && (
                                    <TabPane tab={<span><ContactsOutlined /> Génération manuelle</span>} key="manual">
                                        <ManualCertificateGenerator />
                                    </TabPane>
                                )}
                            </Tabs>
                        </TabPane>
                        <TabPane tab={<span><TrophyOutlined /> Badges</span>} key="6">
                            <BadgeManager courseId={selectedCourse?.id} onSaved={() => reloadCourseDetail(selectedCourse?.id)} />
                        </TabPane>
                    </Tabs>

                    <Button type="primary" shape="circle" icon={<BarChartOutlined />} size="large" style={{ position: "absolute", top: 0, right: 0, background: 'linear-gradient(135deg, #722ed1 0%, #531dab 100%)', border: 'none' }} onClick={() => { setDrawerKey(prev => prev + 1); setDrawerOpen(true); }} />

                    <Drawer title="Statistiques" placement="right" open={drawerOpen} onClose={() => setDrawerOpen(false)} width={380}>
                        {selectedCourse?.id && <TotalPourcentageViewer key={drawerKey} courseId={selectedCourse.id} />}
                    </Drawer>
                </div>
            </Modal>

            <Modal open={isSubjectsModalVisible} title={`Sujetsss : ${selectedCourse?.title || ''}`} footer={null} width="95%" style={{ top: 20 }} bodyStyle={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto' }} onCancel={() => setIsSubjectsModalVisible(false)}>
                {Object.keys(groupedSubjects).length > 0 ? (
                    <Collapse accordion defaultActiveKey={[Object.keys(groupedSubjects)[0]]} bordered={false} style={{ background: '#fafafa' }}>
                        {Object.entries(groupedSubjects).map(([groupName, subjects]) => (
                            <Collapse.Panel header={<span style={{ fontWeight: 600, fontSize: '15px' }}><FolderOpenOutlined style={{ marginRight: 8, color: '#667eea' }} />{groupName}</span>} key={groupName} style={{ marginBottom: '8px', background: 'white', borderRadius: '8px' }}>
                                <Collapse accordion bordered={false}>
                                    {Object.entries(subjects).map(([subjectTitle, subSubjects], idx) => (
                                        <Collapse.Panel header={<span style={{ color: '#667eea', fontWeight: 500 }}>{subjectTitle}</span>} key={subjectTitle}>
                                            {subSubjects.map((subject, subIdx) => {
                                                const attachmentCount = subject.attachmentCount ?? subject.attachments?.length ?? 0;
                                                const resourceCount = subject.resourceCount ?? subject.resources?.length ?? 0;
                                                return (
                                                    <div key={subject.id} className="mc-subject-item">
                                                        <div className="mc-subject-title">{idx + 1}.{subIdx + 1} {subject.subTitle || subject.title}</div>
                                                        <div className="mc-subject-actions">
                                                            <Button size="small" icon={<EditOutlined />} loading={loadingSubjectsId === subject.id} onClick={async () => {
                                                                setLoadingSubjectsId(subject.id); try {
                                                                    const data = await courseService.getSubjectContent(subject.id);
                                                                    handleEditSubject({ ...subject, content: data });
                                                                } catch (e) { message.error("Erreur"); } finally { setLoadingSubjectsId(null); }
                                                            }} style={{ borderRadius: '6px' }}>Modifier</Button>
                                                            <Button size="small" icon={<DeleteOutlined />} danger onClick={() => handleDeleteSubject(subject.id)} style={{ borderRadius: '6px' }}>Supprimer</Button>
                                                            <Button size="small" icon={<PaperClipOutlined />} onClick={() => handleManageAttachments(subject)} style={{ background: '#fa8c16', color: 'white', border: 'none', borderRadius: '6px' }}
                                                            >PJ ({attachmentCount})</Button>

                                                            <Button size="small" icon={<BookOutlined />} onClick={() => handleManageResources(subject)} style={{ background: '#722ed1', color: 'white', border: 'none', borderRadius: '6px' }}>
                                                                Ressources ({resourceCount})</Button>

                                                            <Button size="small" icon={<PlayCircleOutlined />} onClick={() => { setSelectedSubject(subject); setIsModalVisible(true); setSelectedQuiz(null); }} style={{ background: '#52c41a', color: 'white', border: 'none', borderRadius: '6px' }}>Quiz</Button>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </Collapse.Panel>
                                    ))}
                                </Collapse>
                            </Collapse.Panel>
                        ))}
                    </Collapse>
                ) : <Empty description="Aucun sujet disponible" />}
            </Modal>

            <AttachmentManager
                visible={isAttachmentsModalVisible}
                subject={selectedSubject}
                onClose={() => setIsAttachmentsModalVisible(false)}
                onSaved={() => reloadCourseDetail(selectedCourse?.id)}
            />

            <ResourceManager
                visible={isResourcesModalVisible}
                subject={selectedSubject}
                onClose={() => setIsResourcesModalVisible(false)}
                onSaved={() => reloadCourseDetail(selectedCourse?.id)}
            />

            <Modal open={isModalVisible} title="Gestion des Quiz" footer={null} width="75%" onCancel={() => setIsModalVisible(false)}>
                <QuizManager subjectId={selectedSubject?.id} quiz={selectedQuiz} onClose={() => setIsModalVisible(false)} onSaved={() => reloadCourseDetail(selectedCourse?.id)} />
            </Modal>

            <Modal open={isManagementModalVisible} title="Gestion Générale" footer={null} width="95%" style={{ top: 20 }} bodyStyle={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto' }} onCancel={() => setIsManagementModalVisible(false)} destroyOnClose>
                <Tabs defaultActiveKey="1" type="card">
                    <TabPane tab={<span><SettingOutlined /> Plans</span>} key="1"><PlanManager /></TabPane>
                    <TabPane tab={<span><FileImageOutlined /> Actualités</span>} key="2"><NewsManager /></TabPane>
                    <TabPane tab={<span><ContactsOutlined /> Contacts</span>} key="3"><SalesRequestManager /></TabPane>
                </Tabs>
            </Modal>

            <Modal
                open={isPreviewModalVisible}
                title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <EyeOutlined style={{ fontSize: '20px' }} />
                        <span>Prévisualisation : {previewCourse?.title || ''}</span>
                        <span style={{
                            background: 'rgba(255,255,255,0.2)',
                            padding: '4px 12px',
                            borderRadius: '20px',
                            fontSize: '12px',
                            marginLeft: 'auto'
                        }}>
                            👁️ Vue étudiant
                        </span>
                    </div>
                }
                footer={null}
                width="98%"
                style={{ top: 10 }}
                bodyStyle={{
                    padding: 0,
                    height: 'calc(100vh - 100px)',
                    overflow: 'hidden'
                }}
                onCancel={() => {
                    setIsPreviewModalVisible(false);
                    setPreviewCourse(null);
                }}
                destroyOnClose
            >
                {previewCourse && (
                    <div style={{ height: '100%', overflow: 'auto' }}>
                        <CourseFullViewer
                            courseId={previewCourse.id}
                            courseTitle={previewCourse.title}
                        />
                    </div>
                )}
            </Modal>
        </div>
    );
};

export default ModeratorCourses;